@let allContacts = $allAccountContacts(); @let numAllContacts = allContacts?.length; @let visibleContacts =
$visibleAccountContacts(); @let numVisibleContacts = visibleContacts?.length; @let isMessageExists = !!$messenger() ===
true;

<header class="view-header">
  <h2 class="view-header__title">Manage User Access &amp; Permission</h2>
  <button
    type="button"
    class="oneok-button oneok-blue oneok-pill ph-no-capture"
    [disabled]="!$isCanAddNewContact() || $isApiLoading() || $showAccountAdminAcknowledgment()"
    (click)="revealAddNewContactModal()"
  >
    <svg-icon src="/assets/svg/user-plus.svg" />
    <span>Add New User</span>
  </button>
  <button
    type="button"
    class="oneok-button oneok-pill oneok-blue ph-no-capture"
    [disabled]="!$isCanSaveContacts() || $isApiLoading() || $showAccountAdminAcknowledgment()"
    (click)="saveContactPermissions($any($event.target))"
  >
    <svg-icon src="/assets/svg/check.svg" />
    <span>Save All Permissions</span>
  </button>
  <input
    placeholder="Search by name or email"
    type="search"
    [value]='$contactsSearchValue() || ""'
    (input)="$contactsSearchValue.set($event.target.value)"
  />
</header>
@if( !$showAccountAdminAcknowledgment() ){
<section class="view-body">
  <section class="list-controls">
    <div class="list-control">
      <p [class.loading]="allContacts === null">
        @if( allContacts !== null && contactsFilterValue === 'all' ){ {{ allContacts.length }} User{{ allContacts.length
        !== 1 ? 's' : '' }} } @else if( allContacts !== null ){ {{ numVisibleContacts }} of {{ numAllContacts }} Users }
        @else { Retrieving Users&hellip; }
      </p>
    </div>
    <div class="list-control">
      <label for="list-filter">Filter Users by</label>
      <select id="list-filter" (change)="updateContactsFilterOptions($any($event.target).value)">
        @for( contactsFilterOption of $contactsFilterOptions(); track contactsFilterOption.value ){
        <option value="{{ contactsFilterOption.value }}" [selected]="contactsFilterOption.selected">
          {{ contactsFilterOption.label }}
        </option>
        }
      </select>
    </div>
    <div class="list-control">
      <label for="list-sorter">Sort Users by</label>
      <select id="list-sorter" (change)="$contactsSortValue.set($any($event.target).value)">
        @let sortOptions = [{ value: 'name--d', label: 'Last name descending' },{ value: 'name--a', label: 'Last name
        ascending' },{ value: 'login-date--d', label: 'Login date descending' },{ value: 'login-date--a', label: 'Login
        date ascending' }]; @for( sortOption of sortOptions; track sortOption.value ){
        <option value="{{ sortOption.value }}" [selected]="$contactsSortValue() === sortOption.value">
          {{ sortOption.label }}
        </option>
        }
      </select>
    </div>
  </section>
  <section class="list-container">
    @if (!$hasQueriedForContacts()) {
    <!-- prettier-ignore -->
    <p class="loader">Loading <strong [innerHTML]="accountName"></strong>&rsquo;s User(s)&nbsp;&amp;&nbsp;permissions&hellip; Please be patient.</p>
    } @else if ( visibleContacts ){
    <ul
      class="naked list"
      [style]='{
        "display": visibleContacts.length === 0 ? "contents" : null,
        "--name-num-chars": $longestContactNameNumChars()+ "ch"
      }'
    >
      @for( visibleContact of visibleContacts; track visibleContact.id; let visibleContactIdx = $index ){ @let
      hasPreviousLoginDate = visibleContact.loggedInOn.getFullYear() !== 1; @let isActive =
      visibleContact.status.crmRecord === 'active'; @let esaaStatus = visibleContact.esaaStatus;
      <li #visibleContactListItem class="list-item" [class.is-active]="isActive">
        <header
          class="list-item__header"
          tabindex="0"
          role="button"
          (click)="toggleContactView(visibleContactListItem, visibleContact.id)"
          (keydown.enter)="toggleContactView(visibleContactListItem, visibleContact.id)"
          (keydown.space)="toggleContactView(visibleContactListItem, visibleContact.id)"
        >
          <div class="list-item__header-stack" role="group">
            <div class="list-item__header-row">
              <button
                type="button"
                class="list-item__header-button"
                [attr.data-status]='isActive ? "active" : "inactive"'
              >
                <span>{{ visibleContact.name.full }}</span>
              </button>
            </div>
            <div class="list-item__header-row">
              <p class="login-date">
                <em>Status: <strong>{{ isActive ? 'active' : 'inactive' }}</strong></em>
              </p>
              @if( hasPreviousLoginDate ){
              <p class="login-date">
                <em>Last Active: <strong>{{ visibleContact.loggedInOn | date:'MM/dd/yyyy' }}</strong></em>
              </p>
              } @else {
              <p class="login-date">
                <em>Last Active: <strong>Never</strong></em>
              </p>
              }
            </div>
          </div>
          @if( getContactFlattenedSelectedRoles(visibleContact) ){
          <p class="permissions" [innerHTML]="getContactFlattenedSelectedRoles(visibleContact)"></p>
          }
        </header>
        <div class="list-item__body">
          <div class="list-item__part list-item__actions">
            <section class="list-item__ctas">
              <p>Email: <a href="mailto:{{ visibleContact.email }}">{{ visibleContact.email }}</a></p>
              @if( visibleContact.username?.toUpperCase().includes('CUS') ){
              <p>Username: {{ visibleContact.username }}</p>
              }
            </section>
            <section class="list-item__ctas">
              <button
                type="button"
                class="oneok-button oneok-pill danger oneok-outlined--1"
                [disabled]="$isApiLoading()"
                (click)="removeContact(visibleContact.id)"
              >
                <svg-icon src="/assets/svg/user-slash.svg" />
                <span>Remove {{ visibleContact.name.first }}</span>
              </button>
              @if( visibleContact.isQueuedForUpdate ){
              <button
                type="button"
                class="oneok-button oneok-pill oneok-outlined--1"
                [disabled]="$isApiLoading()"
                (click)="saveContactPermissions($any($event.target), visibleContact.id)"
              >
                <svg-icon src="/assets/svg/check.svg" />
                <span>Save {{ visibleContact.name.first }}&lsquo;s Permissions</span>
              </button>
              } @if( visibleContact.isInvitable ){
              <button
                type="button"
                class="oneok-button oneok-pill oneok-outlined--1"
                [disabled]="$isApiLoading()"
                (click)="dispatchContactInvitation($event, visibleContact.id)"
              >
                <svg-icon src="/assets/svg/envelope.svg" />
                <span>{{ visibleContact.status.onboard.includes('invite') ? 'Res' : 'S' }}end invitation</span>
              </button>
              } @if( esaaStatus !== 'no' ){ @let isEsaaSendable = esaaStatus === 'yes';
              <button
                type="button"
                class="oneok-button oneok-pill oneok-outlined--1"
                [disabled]="!isEsaaSendable || $isApiLoading()"
                (click)="sendEsaa( visibleContact )"
              >
                <svg-icon src="/assets/svg/file-signature.svg" />
                <span>{{ isEsaaSendable ? 'Send ESAA' : 'ESAA Pending' }}</span>
              </button>
              }
            </section>
          </div>
          <div class="list-item__part list-item__list">
            @if( visibleContact.segments.length > 1 || numAllContacts > 1 ){
            <section class="roles-controls">
              @if( visibleContact.segments.length > 1 ){ @let rolesGroupId = 'c'+ (visibleContactIdx + 1)
              +'-roles-group';
              <div class="roles-control">
                <label for="{{ rolesGroupId }}">Roles</label>
                <select
                  id="{{ rolesGroupId }}"
                  class="roles-group"
                  (change)="filterContactRoles($event, visibleContact.id)"
                >
                  <option value="all" selected>All</option>
                  @for( rolesGroup of visibleContact.segments; track rolesGroup.name ){
                  <option value="{{ rolesGroup.name }}">{{ rolesGroup.name }}</option>
                  }
                </select>
              </div>
              } @if( numAllContacts > 1 ){ @let peerContacts = getAllVisibleContactsButOne( visibleContact ); @let
              contactsListId = 'c'+ (visibleContactIdx + 1) +'-contacts-list';
              <div class="roles-control">
                <label for="{{ contactsListId }}">Copy roles from</label>
                <select
                  id="{{ contactsListId }}"
                  class="contacts-list"
                  (change)="copyContactRoles($event, visibleContact.id)"
                >
                  <option disabled selected>Select Account peer</option>
                  @for( peerContact of peerContacts; track peerContact.id ){
                  <option value="{{ peerContact.id }}">{{ peerContact.name.full }}</option>
                  }
                </select>
              </div>
              }
            </section>
            } @for( portalRolesGroup of visibleContact.segments; track portalRolesGroup.name; let portalRolesGroupIdx =
            $index ){ @let portalRolesGroupName = portalRolesGroup.name; @let portalRolesGroupList =
            portalRolesGroup.list; @if( portalRolesGroup.visible ){
            <section class="portal-roles">
              <h4 class="portal-roles__heading">{{ portalRolesGroupName }}</h4>
              <ul class="naked">
                @for( portalRole of portalRolesGroupList; track portalRole.id; let portalRoleIdx = $index ){ @let
                portalRoleId = '_'+ (visibleContactIdx + 1) +'-'+ (portalRolesGroupIdx + 1) +'-'+ (portalRoleIdx + 1);
                <li class="portal-roles__role">
                  <input
                    #checkbox
                    value="{{ portalRole.id }}"
                    type="checkbox"
                    [id]="portalRoleId"
                    [checked]="portalRole.selected"
                    (change)="modifyContactPortalRole($event, visibleContact.id)"
                  />
                  <label [for]="portalRoleId">
                    @if( checkbox.checked ){
                    <svg-icon src="/assets/svg/square-check.svg" style="fill: currentColor" />
                    } @else {
                    <svg-icon src="/assets/svg/square.svg" style="fill: currentColor" />
                    }
                    <span>{{ portalRole.name }}</span>
                  </label>
                </li>
                }
              </ul>
            </section>
            } }
          </div>
        </div>
      </li>
      } @empty {
      <li class="no-contacts">
        <span>No <strong [innerHTML]="accountName"></strong> User(s) can be found.</span>
      </li>
      }
    </ul>
    } @else {
    <p class="loader">
      Loading <strong [innerHTML]="accountName"></strong>&rsquo;s User(s)&nbsp;&amp;&nbsp;permissions&hellip; Please be
      patient.
    </p>
    }
  </section>
</section>
@if( isMessageExists ){ @if( $messenger(); as messenger ){
<div class="messenger" [class]='"is-"+ messenger.type'>
  <div [innerHTML]="messenger.message"></div>
  <button type="button" class="oneok-button-icon" (click)="clearMessenger($event)">
    <svg-icon src="/assets/svg/x--small.svg" />
  </button>
</div>
} } }
